import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="container-main">
        <div className="relative bg-gradient-to-br from-primary-500/8 to-accent-500/8 border border-background-200/70 rounded-2xl p-10 md:p-14 text-center overflow-hidden">
          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-4">
              您的被子，值得最专业的呵护
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto mb-8 leading-relaxed">
              无论是蚕丝被、羽绒被还是高端美女被，被护专家都以专业设备与资深技师为您的被芯提供量身定制的洗护方案
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/about"
                className="px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 font-medium rounded-full text-sm hover:bg-primary-600 transition-all duration-200 no-underline whitespace-nowrap cursor-pointer"
              >
                <i className="ri-store-2-line mr-2"></i>了解我们的服务
              </Link>
              <a
                href="tel:4008886666"
                className="px-8 py-3.5 bg-background-50 border border-background-300/60 text-foreground-800 font-medium rounded-full text-sm hover:bg-background-100 transition-all duration-200 no-underline whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>立即预约：400-888-6666
              </a>
            </div>
          </div>

          <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-500/5 rounded-full blur-3xl"></div>
        </div>
      </div>
    </section>
  );
}